<template>
  <v-container
    text-xs-center
  >
    <v-card
      v-show="!loading"
      flat
      class="mx-auto animated fadeIn delay-1s pa-2 pb-5 mb-4"
    >
      <v-layout
        row
        wrap
        justify-end
        style="align-items: center"
      >
        <v-flex
          xs5
          style="text-align: start;"
        >
          <v-btn
            flat
            icon
            class="back-to-catalogue-btn"
            block
            color="primary"
            @click="$router.push('/personalizar')"
          >
            <v-icon class="mr-2">
              $vuetify.icons.arrowLeftIcon
            </v-icon>
            Editar Catálogo
          </v-btn>
        </v-flex>
        <v-flex xs1 />
        <v-flex
          xs6
          style="text-align: end;"
        >
          <v-dialog
            v-model="dialogClear"
            max-width="317"
          >
            <template #activator="{ on }">
              <v-btn
                :disabled="!hasProducts"
                small
                round
                depressed
                class="text-capitalize px-4 clear-cart-btn"
                color="#FFADDE"
                v-on="on"
              >
                <v-icon
                  small
                  class="mr-2"
                >
                  mdi-delete
                </v-icon>
                Limpar Seleção
              </v-btn>
            </template>

            <ActionsDialog
              :dialog-text="`${sellerFirstName}, você tem certeza que deseja limpar a seleção?`"
              first-text="Não, quero manter a seleção"
              second-text="Limpar seleção"
              :first-action="() => { dialogClear = false }"
              :second-action="clearCheckout"
              :close="() => { dialogClear = false }"
            />
          </v-dialog>
        </v-flex>
      </v-layout>

      <v-layout
        v-show="!hasProducts"
        class="py-5"
      >
        <v-flex xs12>
          <span
            class="cart-empty"
          >
            Seu catálogo está vazio
            <v-icon
              left
              color="#433D4E"
              class="ml-2"
            > $vuetify.icons.scaredEmojiIcon
            </v-icon>
          </span>
          <h4 class="my-4 cart-empty-subtitle">
            Adicione produtos para gerar um catálogo personalizado.
          </h4>
          <v-divider style="border: 1px solid #DDDDDD;" />
        </v-flex>
      </v-layout>

      <v-layout
        v-show="hasProducts"
        class="products-catalogue-wrapper"
      >
        <v-flex
          v-for="product in getCatalogue"
          :key="product.reference"
          xs12
          style="border-bottom: 1px solid #DDDDDD;"
        >
          <v-card
            flat
            class="py-4 my-3 mx-1 d-flex"
          >
            <v-img
              id="product-image"
              contain
              :src="product.mainImage"
              class="image-style"
              min-width="150px"
            />

            <v-layout class="mx-2 d-flex direction">
              <v-flex class="alignment mt-2">
                <h5 class="product-reference">
                  Código {{ product.reference }}
                </h5>
                <h3 class="product-name">
                  {{ product.descricaoCurta }}
                </h3>
                <h5 class="product-price mt-3">
                  <s v-if="getStoreSkuPrice(product, 'old')">
                    {{ getStoreSkuPrice(product, 'old') | currency }}
                  </s>
                  <span v-if="product.skus">
                    {{ (getStoreSkuPrice(product, 'regular') || product.preco) | currency }}
                  </span>
                </h5>
              </v-flex>

              <v-flex
                xs1
                class="d-flex justify-start"
                style="align-items: end;"
                :class="{ 'pr-5': $vuetify.breakpoint.mdAndUp }"
              >
                <v-btn
                  small
                  icon
                  style="align-items: end;"
                  @click="openExcludeDialog(product)"
                >
                  <v-icon small>
                    $vuetify.icons.deleteIcon
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-dialog
          v-model="dialogExclude"
          persistent
          max-width="317"
        >
          <ActionsDialog
            dialog-text="Deseja excluir produto?"
            first-text="Cancelar"
            second-text="Excluir"
            :first-action="() => { dialogExclude = false }"
            :second-action="() => { removeProduct(deleteProduct) }"
            :close="() => { dialogExclude = false }"
          />
        </v-dialog>
      </v-layout>
      <!--<div
        v-show="getCatalogue.length > 0"
        class="pick-theme-txt my-3 text-xs-left"
      >
        Escolha um tema para o seu catálogo:
      </div>
       <v-autocomplete
        v-if="templateCatalogue"
        v-model="templateCatalogue"
        class="select my-2"
        data-cy="select-input"
        :items="templateCatalogues"
        item-text="name"
        solo
        return-object
        label="Defina o template do Catalogo"
        persistent-hint
        style="border-radius: 7px;"
      /> -->

      <v-card-actions class="d-block justify-center mx-0 mt-1">
        <v-btn
          block
          color="#140C22"
          class="generate-catalogue-btn px-1 pt-1"
          :loading="loadingCopy"
          :disabled="loading || !hasProducts"
          @click="catalogueAction"
        >
          <v-badge
            left
            overlap
            color="#FF5146"
            :value="getCatalogue.length"
            class="mr-2 mb-1"
          >
            <template #badge>
              <span>
                {{ getCatalogue.length }}
              </span>
            </template>
            <v-icon color="#fff">
              $vuetify.icons.catalogueThinIcon
            </v-icon>
          </v-badge>
          {{ isCatalogue ? 'Atualizar Catálogo' : 'Gerar Catálogo' }}
        </v-btn>
        <v-dialog
          v-model="dialogCopy"
          width="317"
        >
          <v-form
            v-model="catalogueNameValid"
          >
            <v-card
              id="copy-link-dialog"
              class="copy-link-dialog"
            >
              <v-card-title class="copy-link-dialog__close pa-0">
                <v-btn
                  text
                  icon
                  plain
                  depressed
                  class="ma-0"
                  @click="dialogCopy = false"
                >
                  <v-icon
                    small
                  >
                    mdi-close-thick
                  </v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="copy-link-dialog__title  py-0">
                {{ sellerFirstName }}, catálogo gerado com sucesso!
              </v-card-text>

              <v-card-text v-if="!isMaxFavoriteCatalogues">
                Agora você também pode favoritar este
                catálogo para copiar o link quando quiser.
                Ele estará visível na sua lista de catálogos.
              </v-card-text>

              <v-card-text
                v-if="!isMaxFavoriteCatalogues"
                class="py-0 font-weight-bold"
              >
                Dê um nome para favoritar este catálogo:
                <v-text-field
                  v-model="favoriteCatalogueName"
                  placeholder="Exemplo de nome"
                  counter="28"
                  :rules="[rules.characterLimit]"
                />
              </v-card-text>

              <v-card-actions class="copy-link-dialog__actions px-0 py-4 ma-0">
                <v-btn
                  v-if="!isMaxFavoriteCatalogues"
                  class="copy-link-dialog__btn mb-2"
                  medium
                  depressed
                  color="#FFADDE"
                  :loading="loadingCopy"
                  :disabled="!canFavorite"
                  @click="favoriteAndCopyCatalogue"
                >
                  <v-icon
                    medium
                    class="mr-2"
                  >
                    $vuetify.icons.heartOutlineIcon
                  </v-icon>
                  Salvar catálogo como favorito
                </v-btn>
                <v-btn
                  depressed
                  dark
                  color="#140C22"
                  class="copy-link-dialog__btn mb-2"
                  style="z-index: 2;"
                  @click="whatsappCardExpand = !whatsappCardExpand"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-whatsapp
                  </v-icon>
                  Enviar por WhatsApp
                </v-btn>
                <v-expand-transition>
                  <v-card
                    v-show="whatsappCardExpand"
                    height="120"
                    width="288"
                    class="mx-auto mb-2 expand-card"
                  >
                    <v-form
                      v-model="validWhatsapp"
                    >
                      <v-flex
                        class="mx-4 my-4 expand-card-content"
                      >
                        <v-text-field
                          ref="phoneRef"
                          v-model="customerPhone"
                          mask="(##) #####-####"
                          placeholder="(xx) xxxx-xxxx"
                          :rules="[rules.required, rules.min]"
                          class="mr-3 phone-input"
                        />
                        <v-btn
                          block
                          :disabled="!validWhatsapp"
                          color="#140C22"
                          style="color: white; border-radius: 12px"
                          class="primary-btn"
                          @click="sendLinkToCustomer()"
                        >
                          Enviar
                        </v-btn>
                      </v-flex>
                    </v-form>
                  </v-card>
                </v-expand-transition>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-card-actions>
    </v-card>
    <v-progress-circular
      v-if="loading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import { mapGetters } from 'vuex';
import ActionsDialog from '@/components/ActionsDialog';
import { APIService } from '../resources/campanha';
import { FindAllTemplateCatalogue } from '../apollo';
import { EventBus } from '../event-bus';
import { useZipperApi } from '../composables/useZipperApi';

const shortid = require('shortid');

const api = new APIService();
const { client } = useZipperApi();

export default {
  components: {
    ActionsDialog,
  },
  data: () => ({
    catalogue: {},
    catalogueLink: null,
    loader: null,
    phone: null,
    loading: false,
    dialogCopy: false,
    dialogClear: false,
    dialogExclude: false,
    deleteProduct: null,
    templateCatalogues: [],
    templateCatalogue: null,
    whatsappCardExpand: false,
    customerPhone: '',
    favoriteCatalogueFormValid: false,
    sendToCustomerFormValid: true,
    rules: {
      required: (v) => !!v
        || 'Campo Obrigatório',
      min: (value) => (value && value.length === 11)
        || 'Número inválido',
      characterLimit: (v) => v.length <= 28 || 'Limite de caracteres atingido',
    },
    favoriteCatalogueName: null,
    loadingCopy: false,
    catalogueNameValid: false,
    validWhatsapp: false,
  }),
  computed: {
    ...mapGetters(['getStore', 'getCustomer', 'getCatalogue', 'getProfile', 'isMaxFavoriteCatalogues', 'getCatalogueId']),
    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },
    sanitizedPhone() {
      if (!this.customerPhone) return null;
      return this.customerPhone.match(/\d/g).join('');
    },
    whatsappRedirect() {
      const text = encodeURI(`Olá! Acesse seu catálogo pelo link: ${this.catalogueLink}`);
      return `https://wa.me/+55${this.sanitizedPhone}?text=${text}`;
    },
    hasProducts() {
      return this.getCatalogue.length > 0;
    },
    isCatalogue() {
      return this.getCatalogueId.length === 9;
    },
    canFavorite() {
      return !!this.favoriteCatalogueName
        && this.catalogueNameValid;
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      // eslint-disable-next-line no-return-assign
      setTimeout(() => (this[l] = false), 1500);

      this.loader = null;
      this.alert = true;
    },
    getCustomer: {
      handler() {
        this.loader = 'loading';
        this.getTemplateCatalogues();
      },
      immediate: true,
    },
    dialogCopy(val) {
      if (!val) {
        const copyDialogElement = document.getElementById('copy-link-dialog');
        window.Clipboard.copy(this.catalogueLink, copyDialogElement);
        this.dialogCopy = false;
        this.emitSnackbar('Link do catálogo copiado para a área de transferência');
        this.$router.push('/produtos');
      }
    },
  },
  methods: {
    async getTemplateCatalogues() {
      try {
        const res = await this.$apollo.query({
          query: FindAllTemplateCatalogue,
          variables: {
            // eslint-disable-next-line no-underscore-dangle
            customerId: this.getCustomer.id,
          },
          fetchPolicy: 'no-cache',
        });
        this.templateCatalogues = res.data.findAllTemplateCatalogue;
        this.templateCatalogue = this.templateCatalogues.find((el) => el.defaultTemplateCatalogue);
        if (this.templateCatalogue) {
          this.templateCatalogue.name = `${this.templateCatalogue.name} (padrão)`;
        }
      } catch (e) {
        EventBus.$emit('activeSnackBar', {
          text: 'Ocorreu um erro no sistema. Por favor, entre em contato com o suporte.',
          value: true,
          color: 'red',
        });
      }
    },
    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    generateCatalogueURL(catalogueId) {
      if (this.getCustomer.nickname) {
        return `https://${this.getCustomer.nickname.toLowerCase()}.whts.shop/${catalogueId}`;
      }
      return `https://shop.sejazipper.com/${catalogueId}`;
    },
    async createCatalogue() {
      const catalogo = {
        id: shortid.generate(),
        storeId: this.getStore.id,
        customerId: this.getCustomer.id,
        sellerId: this.$auth.user.sub,
        templateCatalogueId: this.getCatalogueId,
        productIds: this.getCatalogue.map((product) => product.idERP),
      };
      this.catalogue = await api.createCatalogue(catalogo);
      this.catalogueLink = this.generateCatalogueURL(this.catalogue.id);
    },
    copiarUrl(targetElement) {
      window.Clipboard.copy(this.url, targetElement);
      this.clearCheckout();
      this.emitSnackbar('Link copiado para a área de transferência');
      this.dialog = false;
    },
    updateAndCopyCatalogue() {
      this.loadingCopy = true;
      const productIds = this.getCatalogue.map((product) => product.idERP);
      this.catalogue = client.chain.mutation
        .updateCatalogueProductIds({
          customerId: this.getCustomer.id,
          catalogueId: this.getCatalogueId,
          sellerId: this.$auth.user.sub,
          productIds,
        })
        .get(true)
        .then((res) => {
          this.catalogue = res;
        });
      this.catalogueLink = this.generateCatalogueURL(this.getCatalogueId);
      this.loadingCopy = true;
      this.copyCatalogueLink(true);
    },
    favoriteAndCopyCatalogue(event) {
      this.loadingCopy = true;
      client.chain.mutation
        .favoriteCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.catalogue.id,
          sellerId: this.$auth.user.sub,
          favoriteName: this.favoriteCatalogueName,
        })
        .get(true);
      this.loadingCopy = false;
      this.emitSnackbar('Catálogo salvo e link copiado para a área de transferência');
      this.copyCatalogueLink(false, event.target);
    },
    copyCatalogueLink(warn, targetElement) {
      this.favoriteCatalogueName = null;
      window.Clipboard.copy(this.catalogueLink, targetElement);
      this.dialogCopy = false;
      if (warn) this.emitSnackbar('Link copiado com sucesso');
      this.$router.push('/produtos');
    },
    async catalogueAction() {
      if (this.isCatalogue) {
        this.updateAndCopyCatalogue();
      }
      await this.createCatalogue();
      this.dialogCopy = true;
    },
    removeProduct(product) {
      this.loader = 'loading';
      this.$store.dispatch('removeCheckout', product);
      this.dialogExclude = false;
      this.deleteProduct = null;
    },
    clearCheckout() {
      this.loader = 'loading';
      this.$store.dispatch('clearCheckout');
      this.dialogClear = false;
    },
    openExcludeDialog(product) {
      this.deleteProduct = product;
      this.dialogExclude = true;
    },
    sendLinkToCustomer() {
      const url = this.whatsappRedirect;
      window.open(url, '_blank');
      this.$refs.phoneRef.reset();
      this.customerPhone = '';
      this.whatsappCardExpand = false;
      this.dialogCopy = false;
    },
    getStoreSkuPrice(product, priceType) {
      const skuByStore = product.skus.find((sku) => sku.idLoja === this.getStore.id && sku.currentStock > 0) || {};

      const prices = {
        old: skuByStore.oldPrice,
        regular: skuByStore.price,
      };

      return prices[priceType];
    },
  },
};
</script>

<style scoped lang="scss">
body {
  background: #e8eeff;
}

.products-catalogue-wrapper {
  display: block;
  margin-bottom: 20px;
}

.image-style {
  border-radius: 4px;
}
.alignment {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-align: start;
}
.direction {
  flex-direction: column;
  height: 150px;
}
.clear-cart-btn {
  width: 144px;
  height: 30px;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  border-radius: 39px;
  background: #FFADDE;
}
.product-reference {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.product-name {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
}
.product-price {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  color: #0C4439;
}
.pick-theme-txt {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #140C22;
}
::v-deep .v-input {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px !important;
  line-height: 18px;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}

.v-card__actions .v-btn + .v-btn {
  margin-left: 0;
}

.expand-card {
  transform: translateY(-30px);
  z-index: 1;
  border: 1px solid #140C22;
  border-radius: 6px;
}

.expand-card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  transform: translateY(15px);
}

.phone-input {
  height: 46px !important;
  padding-left: 5px;
  padding-bottom: 3px;
  border-radius: 6px;
}

.dialog-catalogue-link-title {
  margin-left: 30px;
}

.primary-btn {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 42px;
  color: #140C22;
  border-radius: 7px !important;
  height: 46px;
  text-transform: none;
}

.generate-catalogue-btn {
  position: fixed;
  bottom: 80px;
  left: 0;
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #fff;
  height: 52px;
  text-transform: capitalize;
}

.cart-empty {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #140C22;
}
.cart-empty-subtitle {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.progress-circular {
  height: 50vh !important;
}

.back-to-catalogue-btn {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 102%;
  text-transform: capitalize;
  width: auto;
  border-radius: 20px;
}

.copy-link-dialog {
  width: 100%;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-transform: none;
  border-radius: 7px;
  &__actions {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    height: auto;
  }
  &__btn {
    width: 288px;
    height: 42px;
    border-radius: 7.08982px;
    text-transform: none;
    font-weight: 600;
  }
  &__close {
    display: flex;
    justify-content: end;
  }
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #0C4439;
  }
}

::v-deep .v-badge__badge {
  width: 15px;
  height: 15px;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 12px;
}
</style>
